const isClient = () => typeof window !== "undefined";

export default isClient